import Vue from 'vue'
import Router from 'vue-router'

const Repair = () => import('../views/Repair/Repair.vue');

const projectView = () => import('../views/my_project/index.vue');
const userView = () => import('../views/user/index.vue');
const loginView = () => import('../views/user/login.vue');
const caseModelView = () => import('../views/case/caseModel.vue');
const manageGroupView = () => import('../views/my_project/manageGroup.vue');
const bimModel = () => import('../views/my_project/bimModel.vue');

const Table = () => import('../views/Table/Table.vue');
const PopPage = () => import('../views/Table/Index.vue');
const Drawing = () => import('../views/Table/TableList/Drawing.vue');
const RouterIndex = () => import('../views/Router/Index.vue');

const projectPad = () => import('../views/my_project/new_project/project.vue');
const casePad = () => import('../views/case/new_case/index.vue');

const NewHome = () => import('../views/Home/Index.vue');
const WebNews = () => import('../views/WebNews/WebNews.vue');
const NewsDetail = () => import('../views/WebNews/NewsDetail/NewsDetail.vue');

//案例
const CaseIndex = () => import('../views/case/CaseIndex.vue');

//移动端
const MoblieHome = () => import('views/WebMobile/Home/Index.vue');
const MoblieNews = () => import('views/WebMobile/WebNews/WebNews.vue');
const MoblieNewsDetail = () => import('views/WebMobile/WebNews/NewsDetail/NewsDetail.vue');

//产品服务
const Assessment = () => import('../views/ProductService/Index.vue');
const Check = () => import('../views/ProductService/Check/Check.vue');
const Manage = () => import('../views/ProductService/Manage/ManageIndex.vue');
const Reform = () => import('../views/ProductService/Reform/ReformIndex.vue');
//产品服务 移动端
const MoblieService = () => import('views/WebMobile/ProductServer/Reform/Reform1.vue');
const MoblieReform = () => import('views/WebMobile/ProductServer/Service/Service.vue');
const MoblieAssessment = () => import('views/WebMobile/ProductServer/Assessment/Assessment.vue');
const MoblieCheck = () => import('views/WebMobile/ProductServer/Check/Check.vue');


let isPad = false
let isMobile = false

let width = $(window).width()
if (width<=1200) {
	isPad = true
} else {
	isPad = false
}

if (width <= 750) {
	isMobile = true
} else {
	isMobile = false
}

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes:[
		{
      path: '/',
      name: 'RouterIndex',
			component: RouterIndex,
			meta:{
				keepAlive: true
			},
			children: [
				{
					path: '/',
					component: isMobile? MoblieHome: NewHome,
					name: isMobile? 'MoblieHome' : 'NewHome',
					meta:{
						keepAlive: true
					}
				},
				//产品服务
				{
					path: '/Assessment',
					name: 'Assessment',
					component: Assessment
				},
				//检测
				{
					path: '/Check',
					name: 'Check',
					component: Check
				},
				//建筑可视化
				{
					path: '/Manage',
					name: 'Manage',
					component: Manage
				},
				//维修与改造
				{
					path: '/Reform',
					name: 'Reform',
					component: Reform
				},
				//案例
				{
					path: '/case',
					component: CaseIndex, //caseView,
					name: 'CaseIndex', //'caseView',
					meta:{
						keepAlive: true
					}
				},
				//报检报修
				{
					path: '/Repair',
					component: Repair,
					name: 'Repair',
					// meta:{
					// 	keepAlive: true
					// }
				},
				{
					path: '/project',
					component: isPad?  projectPad: projectView,
					name: isPad?  'projectPad': 'projectView',
					meta:{
						keepAlive: true
					}
				},
				{
					path: '/manageGroup',
					component: manageGroupView,
					name: 'manageGroupView',
					meta:{
						keepAlive: true
					}
				},
				{
					path: '/bimModel',
					component: bimModel,
					name: 'bimModel',
					meta: {
						header: 'false'
					}
				},
				// 新新闻
				{
					path: '/WebNews',
					component: isMobile? MoblieNews : WebNews,
					name: isMobile? 'MoblieNews' : 'WebNews',
					meta:{
						keepAlive: true
					}
				},
				{
					path: '/NewsDetail',
					component: isMobile?  MoblieNewsDetail : NewsDetail,
					name: isMobile? 'MoblieNewsDetail' : 'NewsDetail',
				},
				{
					path: '/user',
					component: userView,
					name: 'userView'
				},
				{
					path: '/login',
					component: loginView,
					name: 'loginView',
				},
				{
					path: '/model',
					component: isPad?  casePad: caseModelView,
					name: isPad?  'casePad': 'caseModelView',
				},
				{
					path: '/Table',
					component: Table,
					name: 'Table',
				},
				{
					path: '/MoblieReform',
					name: 'MoblieReform',
					component: MoblieReform,
				},
				{
					path: '/MoblieService',
					name: 'MoblieService',
					component: MoblieService,
				},
				{
					path: '/MoblieAssessment',
					name: 'MoblieAssessment',
					component: MoblieAssessment,
				},
				{
					path: '/MoblieCheck',
					name: 'MoblieCheck',
					component: MoblieCheck,
				},
			]
		},
    {
      path: '/PopPage',
      name: 'PopPage',
      component: PopPage
    },
    {
      path: '/Drawing/:token',
      name: 'Drawing',
      component: Drawing
		},
    {
      path: '/casePad',
      name: 'casePad',
      component: casePad
		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js